import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext } from 'react';
import { Header } from 'semantic-ui-react';
import { VariantProvider, MenuProvider, FoodMenuCartProvider } from './FoodMenu.context';
import { computeVariants, getCart } from './FoodMenu.utils';
import MenuNavigation from './components/MenuNavigation';
import { CartContext } from '../../contexts/CartContext';
import { BusinessPropType, CarPropType, MenuPropType } from '../../services/proptypes';
import './FoodMenu.css';
export default function FoodMenu(_ref) {
  var navDisplayVariant = _ref.navDisplayVariant,
    categoryDisplayVariant = _ref.categoryDisplayVariant,
    itemDisplayVariant = _ref.itemDisplayVariant,
    itemCartModalVariant = _ref.itemCartModalVariant,
    menu = _ref.menu,
    header = _ref.header,
    navigationHeader = _ref.navigationHeader,
    centerHeader = _ref.centerHeader,
    centerNavigation = _ref.centerNavigation,
    stackedNavigation = _ref.stackedNavigation,
    disableModifiers = _ref.disableModifiers,
    disableSchedules = _ref.disableSchedules,
    disableDescription = _ref.disableDescription,
    disableScheduleAvailability = _ref.disableScheduleAvailability,
    cart = _ref.cart,
    precision = _ref.precision,
    showCategoryDropdown = _ref.showCategoryDropdown,
    showMenuLikes = _ref.showMenuLikes,
    business = _ref.business,
    displayZeroCostItemPrices = _ref.displayZeroCostItemPrices,
    displayZeroCostModifierPrices = _ref.displayZeroCostModifierPrices;
  var variantContext = {
    navDisplay: navDisplayVariant,
    categoryDisplay: categoryDisplayVariant,
    itemDisplay: itemDisplayVariant,
    itemCartModal: itemCartModalVariant
  };
  var headerStyle = centerHeader ? {
    textAlign: 'center'
  } : {};
  var _useContext = useContext(CartContext),
    cartContext = _useContext.cart;
  var finalCart = getCart(cart, cartContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(VariantProvider, {
    value: computeVariants(variantContext)
  }, /*#__PURE__*/React.createElement(MenuProvider, {
    value: _objectSpread(_objectSpread({}, menu), {}, {
      precision: precision,
      disableModifiers: disableModifiers,
      disableSchedules: disableSchedules,
      disableDescription: disableDescription,
      showCategoryDropdown: showCategoryDropdown,
      showMenuLikes: showMenuLikes,
      business: business,
      displayZeroCostItemPrices: displayZeroCostItemPrices,
      displayZeroCostModifierPrices: displayZeroCostModifierPrices,
      disableScheduleAvailability: disableScheduleAvailability
    })
  }, /*#__PURE__*/React.createElement(FoodMenuCartProvider, {
    value: finalCart
  }, header && /*#__PURE__*/React.createElement(Header, {
    as: "h1",
    className: "fcfm-main-header",
    style: headerStyle
  }, header), /*#__PURE__*/React.createElement(MenuNavigation, {
    center: centerNavigation,
    header: navigationHeader,
    stacked: stackedNavigation
  })))));
}
FoodMenu.defaultProps = {
  navDisplayVariant: 'BasicTabs',
  categoryDisplayVariant: 'VerticalList',
  itemDisplayVariant: 'Basic',
  itemCartModalVariant: 'CatalogItemCartModal',
  header: 'Menu',
  navigationHeader: '',
  centerHeader: false,
  showCategoryDropdown: true,
  centerNavigation: false,
  stackedNavigation: false,
  disableModifiers: false,
  disableSchedules: false,
  disableDescription: false,
  disableScheduleAvailability: false,
  showMenuLikes: true,
  cart: false,
  precision: 2,
  displayZeroCostItemPrices: false,
  displayZeroCostModifierPrices: false
};